// 🏷️ VALORES DE EXAME LAB → TEXTO PARA A IA (B358-FU4, AI_156)
// ─────────────────────────────────────────────────────────────
// O campo `MELD` gravado no exame é o MELD 3.0 (o que o sistema calcula). Ia à
// IA com o rótulo cru "MELD", e a análise o tratava como "o MELD" — usando-o no
// lugar do MELD-Na, que é o escore de alocação VIGENTE em SP (B358-FU2), mesmo
// com o MELD-Na presente no prompt. Rotular o dado na fonte (lição
// [[rotular-dado-em-vez-de-regra]]) em vez de somar regra de prompt.
// Só o TEXTO enviado à IA muda; a chave `MELD` segue igual para os demais
// consumidores (meldDeExame, TextoLivre, buscarContexto, fatosVerificados).
// ⟳ REVISAR quando a Portaria 8.041 (MELD 3.0 como alocação) entrar em vigor.
// ─────────────────────────────────────────────────────────────

export function valoresLabParaIA(valores: unknown): string {
  if (!valores || typeof valores !== "object") return JSON.stringify(valores);
  const saida: Record<string, unknown> = {};
  for (const [chave, valor] of Object.entries(valores as Record<string, unknown>)) {
    saida[chave === "MELD" ? "MELD 3.0" : chave] = valor;
  }
  return JSON.stringify(saida);
}

/**
 * Cópia dos dados com o MELD dos exames rotulado "MELD 3.0" — para a Etapa 2 da
 * análise geral, que recebe o JSON dos dados (e não o texto do prompt).
 */
export function examesComMeldRotulado<T extends { examesLab?: Array<{ valores?: unknown }> }>(
  dados: T
): T {
  if (!Array.isArray(dados.examesLab)) return dados;
  return {
    ...dados,
    examesLab: dados.examesLab.map((e) =>
      e && e.valores && typeof e.valores === "object"
        ? { ...e, valores: JSON.parse(valoresLabParaIA(e.valores)) }
        : e
    ),
  };
}
